import React from "react";
import {useTranslation} from "react-i18next";
// local
import {LockValue} from "components/LockValue";
import {SkeletonRectValue} from "components/SkeletonRectValue";
import FinancialSnapshotSelect from "components/selects/FinancialSnapshotSelect";

const CreditSnapshot = ({companyNumber, initialSnapshots}) => {
  const {t} = useTranslation();

  return (
    <div className="presentation-page__left-side__cards">
      <LockValue
        canPermissions={["ENABLE_COMPANY_CREDITSAFE_SNAPSHOTS"]}
        needLabel
        needRightIcon={false}
        noHideOurInfo
        addClassIcon="mb-2"
      >
        <h5>{t("CREDIT_SNAPSHOT_LEFT_SIDE")}</h5>
      </LockValue>

      <SkeletonRectValue
        quantity={4}
        canPermissions={["ENABLE_COMPANY_CREDITSAFE_SNAPSHOTS"]}
        noHideOurInfo
      >
        <div className="mt-2 mb-1">
          <FinancialSnapshotSelect
            companyNumber={companyNumber}
            initialSnapshots={initialSnapshots}
            addClass="presentation-page__credit-snapshot"
          />
        </div>
      </SkeletonRectValue>
    </div>
  );
};

export default CreditSnapshot;
